function _arrayReduce(reducer, acc, list) {
  var index = 0;
  var length = list.length;

  while (index < length) {
    acc = reducer(acc, list[index]);
    index += 1;
  }

  return acc;
}

module.exports = _arrayReduce;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reduxsauce/node_modules/ramda/src/internal/_arrayReduce.js
// module id = 160
// module chunks = 57